import { render } from "./out.vue?vue&type=template&id=04db610e&scoped=true"
import script from "./out.vue?vue&type=script&lang=js"
export * from "./out.vue?vue&type=script&lang=js"

import "./out.vue?vue&type=style&index=0&id=04db610e&lang=scss&scoped=true"
import "./out.vue?vue&type=style&index=1&id=04db610e&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04db610e"]])

export default __exports__